<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar
      :border="false"
      title="项目参与"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="page-project-wrap box">
      <div class="item"><span>项目名称：</span>全效智能体数据录入</div>
      <div class="item"><span>项目编号：</span>84525</div>
      <div class="item"><span>项目金额：</span>10000</div>
      <div class="item"><span>项目时间：</span>2021.01.25至2021.01.30</div>
      <div class="item"><span>项目标签：</span>内部</div>
      <div class="item"><span>参与人数：</span>3</div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <div class="tip">
          全效智能体数据录入，用于绩效评估与岗位技能鉴定分析。
        </div>
      </div>
    </div>
    <div class="page-dep-wrap box">
      <div class="item">
        <span>参与部门：</span>
        <div class="info">
          <p>技术中心</p>
        </div>
      </div>
      <div class="item">
        <span>出资部门：</span>
        <div class="info">
          <p>财务中心</p>
          <p>总经办</p>
          <p>市场中心</p>
        </div>
      </div>
      <div class="item">
        <span>验收人员：</span>
        <div class="info">
          <p>技术中心-总监-陈军</p>
        </div>
      </div>
    </div>
    <div class="page-member-wrap box">
      <div class="title">
        <span class="s1">参与人员</span>
        <span class="s2">权重</span>
        <span class="s2">进度</span>
      </div>
      <div class="info-wrap">
        <div class="info-item">
          <span class="s1">技术中心-总监-陈军</span>
          <span class="s2">10%</span>
          <span class="s2">10%</span>
        </div>
        <div class="info-item">
          <span class="s1">技术中心-总监-陈军</span>
          <span class="s2">10%</span>
          <span class="s2">10%</span>
        </div>
        <div class="info-item">
          <span class="s1">技术中心-总监-陈军</span>
          <span class="s2">10%</span>
          <span class="s2">10%</span>
        </div>
      </div>
    </div>

    <div class="submit-btn">申请参与</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pValue: 30
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/project/ProjectJoin.vue